export default {
  label: 'Páginas',
  placeholder: 'Todas',
  selected: 'selecionado',
  selectedPlural: 'selecionados',
};
